import { render, staticRenderFns } from "./PrintedBills.vue?vue&type=template&id=31a0ccd2&scoped=true"
import script from "./PrintedBills.vue?vue&type=script&lang=js"
export * from "./PrintedBills.vue?vue&type=script&lang=js"
import style0 from "./PrintedBills.vue?vue&type=style&index=0&id=31a0ccd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a0ccd2",
  null
  
)

export default component.exports